export const SUPPORTED_LEARNING_FEATURE_TYPES = [
  'learn',
  'video',
  'conversation',
  'review',
  'pronunciation',
  'sentence_builder',
] as const;

export type LearningFeatureType = (typeof SUPPORTED_LEARNING_FEATURE_TYPES)[number];

export interface LearningFeature {
  type: LearningFeatureType;
  skippable: boolean;
}

export interface LearningQueueResponse {
  lastUpdated: string;
  learningFeatures: LearningFeature[];
}
